/* import __COLOCATED_TEMPLATE__ from './cancel-credit-modal.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { all, dropTask } from 'ember-concurrency';
import { BUTTON_TYPES } from 'sh-www/constants/lsg';
import { showNextModal, closeModal } from 'sh-www/utils/modal-controls';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';

const CLASS_NAME = 'SH-c-reports-cancel-credit-modal';

class ReportsCancelCreditModal extends Component {
  @service('commands/company-credit-commands') companyCreditCommandService;

  get className() {
    return CLASS_NAME;
  }

  get submitDisabled() {
    return this.cancelCredit.isRunning;
  }

  get invoiceIdentifier() {
    const { shGeneralInvoice } =  this.args.model;

    return shGeneralInvoice.related?.costCode?.body ?? `#${shGeneralInvoice.id}B`;
  }

  @dropTask
  *cancelCredit() {
    const {
      shGeneralInvoice,
      loadCompanyCostCodeCreditsTask,
      loadCreditUnpaidInvoicesTask,
      loadCreditDeletedInvoicesTask,
      loadCompanyCreditFactoidsTask,
      updateCompanyCreditFactoids,
      updateCompanyCostCodeCredits,
      updateShGeneralDeletedInvoices,
      updateShGeneralUnpaidInvoices,
    } = this.args.model;

    try {
      // perform add
      yield this.companyCreditCommandService.destroyCompanyCredit(shGeneralInvoice.relatedId);
    } catch (e) {
      handleErrorResponseWithModal(this, e);
      return;
    }

    try {
       // reload all affected balances
       const [
        creditDeletedInvoices,
        companyCostCodeCredits,
        companyCreditFactoids,
        creditUnpaidInvoices,
      ] = yield all([
        loadCreditDeletedInvoicesTask.perform(),
        loadCompanyCostCodeCreditsTask.perform(),
        loadCompanyCreditFactoidsTask.perform(),
        loadCreditUnpaidInvoicesTask.perform(),
      ]);

      // update data
      updateCompanyCreditFactoids(companyCreditFactoids);
      updateCompanyCostCodeCredits(
        companyCostCodeCredits.costCodes,
        companyCostCodeCredits.costCodesCurrentPage,
      );
      updateShGeneralDeletedInvoices(
        creditDeletedInvoices.shGeneralDeletedInvoices,
        creditDeletedInvoices.shGeneralDeletedInvoicesPagination,
      );
      updateShGeneralUnpaidInvoices(
        creditUnpaidInvoices.shGeneralUnpaidInvoices,
        creditUnpaidInvoices.shGeneralUnpaidInvoicesPagination,
      );

      // show success
      showNextModal(this, 'confirmation', {
        classNames: `${CLASS_NAME}__success-modal`,
        titleText: 'Credit Canceled',
        bodyText: 'Since an invoice has already been issued for this credit, make sure to alert your finance department to let them know this invoice is void.',
        actionButtonText: 'Got it',
        width: 'medium',
        actionButtonLsgButtonType: BUTTON_TYPES.PRIMARY_REGULAR,
        iconName: 'warning',
        isDismissible: false,
      });
    } catch (e) {
      handleErrorResponseWithModal(
        this,
        e,
        'Partial credit payment canceled but failed to reload data. Please refresh the page.',
      );
    }
  }

  @action
  handleDismiss() {
    closeModal(this);
  }
}

export default ReportsCancelCreditModal;
